import { FC, useCallback, useEffect } from 'react';

import { report } from '@adsk/exo-skeleton-api';

import { useCustomHelpLink } from './CustomHelpLinkContext';

export type CustomHelpLinkProps = {
  link: string | undefined;
};

export const CustomHelpLink: FC<CustomHelpLinkProps> = ({ link }) => {
  const { link: currentLink, setLink } = useCustomHelpLink();

  const setLinkWithValidation = useCallback(
    (newLink: string) => {
      try {
        setLink(newLink);
      } catch (error: unknown) {
        report({
          scope: 'CustomHelpLink',
          context: {},
          type: 'error',
          value: error as Error,
        });
      }
    },
    [setLink],
  );

  useEffect(() => {
    if (link && link !== currentLink) {
      setLinkWithValidation(link);
    }
  }, [currentLink, link, setLinkWithValidation]);

  return null;
};
